<template>
    <tr v-if="collapseActive" class="licence__show_table_item_collapse_table">
        <td class="licence__show_table_item_collapse_table_wrapper" colspan="4">
            <template v-if="requestPending">
                <component-loading :size="'small'"></component-loading>
            </template>
            <template v-else>
                <table>
                    <tbody>
                    <template
                        v-for="(attempt, index) in licenceAttempts"
                    >
                        <licence-show-table-collapse-table-item
                            :item="attempt"
                            :key="`licence-show-table-collapse-table-item-${index}`"
                        ></licence-show-table-collapse-table-item>
                    </template>
                    </tbody>
                </table>
            </template>
        </td>
    </tr>
</template>

<script>
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import LicenceShowTableCollapseTableItem from '@/components/ebs/licences/show/LicenceShowTableItemCollapseTableItem'

export default {
  name: 'licence-show-table-collapse-table',
  components: { LicenceShowTableCollapseTableItem, ComponentLoading },
  data () {
    return {
      requestPending: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    licenceAttempts () {
      return this.item.attempts
    },
    licenceEnrolmentId () {
      return this.item.id
    }
  },
  watch: {
    collapseActive (value) {
      if (value) {
        this.performGetLicenceAttempts()
      }
    }
  },
  methods: {
    performGetLicenceAttempts () {
      if (!this.collapseActive) return

      this.requestPending = true
      this.$store.dispatch('ebsLicenceConsumptionsGetAttempts', this.licenceEnrolmentId).finally(() => {
        this.requestPending = false
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/licences/_licenceshowlisttableitemcollapse.scss";
</style>
